const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { PORTFOLIO_SAVED_VIEW_BASE } from '@/features/views/hooks/useViewSurfacePaths';
import { saveLastVisitedView } from '@/features/visualizations/utils/lastVisitedVisualizationView';
import { urlSegmentToVisualizationType, visualizationTypeToUrlSegment } from '@/features/visualizations/utils/visualizationTypeToUrlSegment';
const paramsSchema = z.object({
  viewId: z.coerce.number().int().positive()
});
type SavedViewBeforeLoadArgs = CombinedTabBeforeLoadArgs & {
  params: {
    viewId: number;
  };
  location: {
    pathname: string;
  };
};
export const visualizationsSavedViewBeforeLoad = ({
  context,
  params,
  location
}: SavedViewBeforeLoadArgs) => {
  if (!context.flags.enableCombinedPortfolioAndVisualizationsTab) return;
  if (location.pathname.includes('/preview/')) return;
  const lastSegment = location.pathname.split('/').filter(Boolean).at(-1);
  const visualizationType = lastSegment ? urlSegmentToVisualizationType(lastSegment) : undefined;
  throw redirect({
    to: visualizationType ? `${PORTFOLIO_SAVED_VIEW_BASE}/${visualizationTypeToUrlSegment(visualizationType)}` : PORTFOLIO_SAVED_VIEW_BASE,
    params,
    replace: true
  });
};
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/view/$viewId')({
  params: paramsSchema,
  beforeLoad: visualizationsSavedViewBeforeLoad,
  loader: ({
    params
  }) => saveLastVisitedView(Number(params.loopId), {
    type: 'view',
    id: Number(params.viewId)
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});